<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import useUserStore from '@/stores/userStore';
import useComponentsStore from '@/stores/components';
import VersionPanel from '@/components/VersionPanel.vue';

useUserStore();
const { components } = useComponentsStore();
const route = useRoute();

const layoutComponentName = computed(() => route.meta.layout ?? 'none-layout');

</script>
<template>
  <!-- router-view -->
  <component :is="layoutComponentName">
    <router-view />
  </component>

  <!-- component -->
  <component
    v-for="[id, value] in Object.entries(components)"
    :key="`component-${id}`"
    :is="value"
    :id="id"
  />
  <VersionPanel />
</template>
